const STAGING = 'staging';
const PRODUCTION = 'production';

const CHAT_HANDOFF_SUCCESS = 'chat_handoff_success';
const CHAT_HANDOFF_FAILURE_MESSAGE = 'chat_handoff_failure_message';
const HANDOFF_BUTTON_STEP_OUTPUT = 'handoff_button_step_output';

const PREFIX_TO_SKIP_RENDERING_WIDGET_COMPONENT = 'Conversation Transcript:';

const THREE_SECONDS = 1000 * 3;

const ARTIFICIAL_DELAY_IN_MILLISECONDS = 2000;

const FAKE_AUTOFLOWS_STEP_ID = '8c244f85-af73-4f72-a599-40b3c9bb297e';

const SUNCO_WAIT_TIME_NAME = 'forethought_bot_wait_time';

export {
  ARTIFICIAL_DELAY_IN_MILLISECONDS,
  CHAT_HANDOFF_FAILURE_MESSAGE,
  CHAT_HANDOFF_SUCCESS,
  FAKE_AUTOFLOWS_STEP_ID,
  HANDOFF_BUTTON_STEP_OUTPUT,
  PREFIX_TO_SKIP_RENDERING_WIDGET_COMPONENT,
  PRODUCTION,
  STAGING,
  THREE_SECONDS,
  SUNCO_WAIT_TIME_NAME,
};
